export const DEFAULT_API_DATE_TIME_FORMAT = "MMMM d, yyyy 'at' h:mm a"
export const DEFAULT_API_DATE_FORMAT = 'MMMM d, yyyy'
export const DEFAULT_API_TIME_FORMAT = 'h:mm a'
